import React from 'react'
import { Link } from 'react-router-dom'
import { Cog6ToothIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline'
import KafelekModulu from './KafelekModulu'
import { useTranslation, Trans } from 'react-i18next'

/**
 * Sekcja modułów w trybie „TYLKO wybrane moduły" (KitPreferences.module_scope
 * = `slots`).
 *
 * ═══ DLACZEGO ZAMIAST, A NIE OBOK ═══
 * Przy włączonym trybie twardym silnik i tak dobiera wyłącznie spośród tych
 * modeli. Zostawienie pól „moc modułu", „tolerancja" i filtrów zaawansowanych
 * dawałoby kontrolki, które albo nic nie zmieniają, albo zawężają zbiór do
 * pustego — a użytkownik nie ma jak zgadnąć, która z tych dwóch rzeczy się
 * właśnie stała. Zamiast tego pokazujemy wprost, z czego wybieramy.
 *
 * Kafelek jest ten sam co w preferencjach doboru (`KafelekModulu`) — ze
 * zdjęciem, producentem, mocą, rodzajem i ceną. Ten sam moduł ma wyglądać
 * tak samo w obu miejscach.
 *
 * Wybór PRZYPINA moduł do zestawu. Brak wyboru zostawia decyzję silnikowi —
 * wtedy szuka najlepszego zestawu z całej listy.
 *
 * ═══ PUSTA LISTA TO NIE BŁĄD ═══
 * Sloty rozwiązują się do bieżących ofert. Gdy żadna nie spełnia kryteriów
 * (skończył się stan, cena wyszła poza próg), lista jest pusta i mówimy o tym
 * wprost razem z drogą wyjścia — cichy powrót do dowolnych modułów podstawiłby
 * produkty, których firma świadomie nie chce wyceniać.
 *
 * „Dobierz inne” (`onDobierzInne`, 2026-10-30) to świadomy wybór użytkownika, tylko w tym doborze: pokazuje zwykłą
 * sekcję modułów. Ustawienia konta zostają bez zmian.
 */
const WybraneModuly = ({ oferty, przypiety, onPrzypnij, onDobierzInne }) => {
  const { t } = useTranslation('asystent')
  const pusto = !oferty || oferty.length === 0

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm">
      <div className="px-4 md:px-5 pt-4 pb-3 border-b border-gray-100">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-sm font-bold text-gray-900">{t('wybrane_moduly.naglowek')}</h3>
            <p className="text-xs text-gray-500 mt-1 leading-5">
              {t('wybrane_moduly.opis')}
            </p>
          </div>
          <div className="flex flex-wrap justify-end gap-x-3 gap-y-1">
            <Link
              to="/preferencje"
              className="inline-flex items-center gap-1.5 text-xs font-medium text-blue-600
                         hover:text-blue-700 whitespace-nowrap no-underline"
            >
              <Cog6ToothIcon className="w-4 h-4" />
              {t('wybrane_moduly.zmien')}
            </Link>
            {onDobierzInne && (
              <button
                type="button"
                onClick={onDobierzInne}
                className="inline-flex items-center gap-1.5 text-xs font-medium text-blue-600
                           hover:text-blue-700 whitespace-nowrap"
              >
                <ArrowsRightLeftIcon className="w-4 h-4" />
                {t('wybrane_moduly.dobierz_inne')}
              </button>
            )}
          </div>
        </div>
      </div>

      {pusto ? (
        <div className="px-4 md:px-5 py-5">
          <p className="text-sm text-amber-700 leading-6">
            <Trans t={t} i18nKey="wybrane_moduly.pusto"
              components={{ link: <Link to="/preferencje" className="font-semibold underline underline-offset-2" /> }} />
          </p>
        </div>
      ) : (
        <div className="p-3 md:p-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {oferty.map((o) => (
              <KafelekModulu
                key={o.model_id}
                oferta={o}
                wybrany={przypiety?.model_id === o.model_id}
                onWybierz={onPrzypnij}
              />
            ))}
          </div>
          <p className="text-xs text-gray-500 px-1 pt-3 leading-5">
            {przypiety
              ? t('wybrane_moduly.zaznaczony')
              : t('wybrane_moduly.nie_musisz')}
          </p>
        </div>
      )}
    </div>
  )
}

export default WybraneModuly
